import React, { useEffect, useState } from 'react';
import * as api from '../../billMemory/api';

const VERSION_STATUS = { draft: 'draft, waiting for review', reviewed: 'reviewed', shadow: 'being measured (Shadow)', live: 'live', retired: 'retired' };

/** Dictionary: the starter groups, read-only, each with an On/Off switch for this business. */
export default function DictionaryTab({ canEdit }) {
  const [d, setD] = useState(null);
  const load = () => api.getDictionary().then(setD).catch(() => setD({ version: null, groups: [] }));
  useEffect(() => { load(); }, []);
  if (!d) return <div className="bm-note">Loading…</div>;
  if (!d.version) return <div className="bm-note">No starter dictionary yet.</div>;
  return (
    <div className="bm-tab">
      <div className="bm-count">{`Starter dictionary version ${d.version} (${VERSION_STATUS[d.status] || d.status}), ${d.groups.length} groups`}</div>
      <table className="irr-qty-table bm-table">
        <thead><tr><th>Group</th><th>Names</th><th>Kind</th><th>On for this business</th></tr></thead>
        <tbody>
          {d.groups.map((g) => (
            <tr key={g.group_key}>
              <td>{g.group_key}</td>
              <td>{(g.names || []).map((n) => (typeof n === 'string' ? n : n.text)).join(', ')}</td>
              <td>{g.kind === 'regional' ? 'Regional (only suggests)' : 'Fixed'}</td>
              <td>
                <input type="checkbox" checked={g.on} disabled={!canEdit} aria-label={`${g.group_key} on`}
                  onChange={async (e) => { await api.setGroup(g.group_key, e.target.checked).catch(() => {}); load(); }} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
